module.exports = __webpack_public_path__ + "static/media/running.5c669643.svg";